//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../circleCommon.scss'

// @ADD Component types
interface ICircleCommonLayoutProps {
  size?: any
  color?: any
  tooltip?: {placement: 'top' | 'left' | 'bottom' | 'right', label: string}
}

const CircleCommonLayout: React.FC<ICircleCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <>
      {props.tooltip ? (
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement={props.tooltip.placement}
          overlay={
            <Tooltip id='toolip-circle'>
              {props.tooltip.label}
            </Tooltip>
          }>
          <div className='circle-component' style={{width: props.size, height: props.size, backgroundColor: props.color}} />
        </OverlayTrigger>
      ) : (
        <div className='circle-component' style={{width: props.size, height: props.size, backgroundColor: props.color}} />
      )}
    </>
  )
}

export default CircleCommonLayout
